import { gql } from '@apollo/client'

import { ROLES_ATTRIBUTES } from '../permissions/graphQL'

const ADMIN_USER_ATTRIBUTES = gql`
  fragment adminUserAttributes on AdminUser {
    id
    createdAt
    updatedAt
    archivedAt
    latestActivity
    mobile
    roles {
      id
      name
    }
    user {
      id
      firstName
      lastName
      email
      userIdentity
    }
    projects {
      id
      name
      status
    }
    limitedPermissions
  }
`

export const GET_ADMIN_USERS = gql`
  query adminUsers_UI(
    $filter: AdminUserFilterInput
    $pagination: PaginationInput
    $sort: AdminUserSortInput
    $searchString: String
  ) {
    adminUsers(
      filter: $filter
      pagination: $pagination
      sort: $sort
      searchString: $searchString
    ) {
      ...adminUserAttributes
      user {
        profilePicture {
          url
        }
      }
    }
    adminUsersAggregation(
      filter: $filter
      pagination: $pagination
      sort: $sort
      searchString: $searchString
    ) {
      totalCount
      totalPages
      offset
      limit
    }
  }
  ${ADMIN_USER_ATTRIBUTES}
`

export const GET_ADMIN_USERS_BASIC_INFO = gql`
  query adminUsersBasicInfo_UI($filter: AdminUserFilterInput) {
    adminUsers(filter: $filter) {
      id
      mobile
      user {
        firstName
        lastName
        email
      }
    }
  }
`

export const GET_ADMIN_USER_LICENSE_COUNT = gql`
  query adminUserLicenseCount_UI($filter: AdminUserFilterInput) {
    adminUsersAggregation(filter: $filter) {
      totalCount
    }
  }
`

export const GET_ADMIN_USERS_LIST = gql`
  query adminUsersList_UI(
    $filter: AdminUserFilterInput
    $pagination: PaginationInput
    $sort: AdminUserSortInput
    $searchString: String
  ) {
    adminUsers(
      filter: $filter
      pagination: $pagination
      sort: $sort
      searchString: $searchString
    ) {
      id
      user {
        id
        firstName
        lastName
      }
    }
    adminUsersAggregation(
      filter: $filter
      pagination: $pagination
      sort: $sort
      searchString: $searchString
    ) {
      totalCount
      totalPages
      offset
      limit
    }
  }
`

export const GET_ADMIN_USERS_CSV = gql`
  query adminUsersCsv_UI($filter: AdminUserFilterInput, $searchString: String) {
    adminUsers(filter: $filter, searchString: $searchString) {
      ...adminUserAttributes
    }
  }
  ${ADMIN_USER_ATTRIBUTES}
`

export const GET_ADMIN_USERS_FOR_SEARCH = gql`
  query adminUsersForSearch_UI(
    $filter: AdminUserFilterInput
    $pagination: PaginationInput
    $sort: AdminUserSortInput
    $searchString: String
  ) {
    adminUsers(
      filter: $filter
      pagination: $pagination
      sort: $sort
      searchString: $searchString
    ) {
      id
      user {
        firstName
        lastName
        email
      }
    }
    adminUsersAggregation(
      filter: $filter
      pagination: $pagination
      sort: $sort
      searchString: $searchString
    ) {
      totalCount
      totalPages
      offset
      limit
    }
  }
`

export const GET_ADMIN_USERS_ROLES = gql`
  query roles_UI {
    roles {
      id
      name
      ...rolesAttributes
    }
  }

  ${ROLES_ATTRIBUTES}
`

export const INVITE_ADMIN_USER = gql`
  mutation inviteAdminUser_UI($input: InviteAdminUserInput!) {
    inviteAdminUser(input: $input) {
      ...adminUserAttributes
    }
  }
  ${ADMIN_USER_ATTRIBUTES}
`

export const UPDATE_ADMIN_USER = gql`
  mutation updateAdminUser_UI($id: String!, $input: UpdateAdminUserInput!) {
    updateAdminUser(id: $id, input: $input) {
      ...adminUserAttributes
    }
  }
  ${ADMIN_USER_ATTRIBUTES}
`

export const UPDATE_ADMIN_USER_ROLES = gql`
  mutation updateAdminUserRoles_UI($id: String!, $roleIds: [String]!) {
    updateAdminUserRoles(id: $id, roleIds: $roleIds) {
      ...adminUserAttributes
    }
  }
  ${ADMIN_USER_ATTRIBUTES}
`

export const ARCHIVE_ADMIN_USER = gql`
  mutation archiveAdminUser_UI($id: String!) {
    archiveAdminUser(id: $id) {
      ...adminUserAttributes
    }
  }
  ${ADMIN_USER_ATTRIBUTES}
`

export const UNARCHIVE_ADMIN_USER = gql`
  mutation unarchiveAdminUser_UI($id: String!) {
    unarchiveAdminUser(id: $id) {
      ...adminUserAttributes
    }
  }
  ${ADMIN_USER_ATTRIBUTES}
`

export const REINVITE_ADMIN_USER = gql`
  mutation reinviteAdminUser_UI($id: String!) {
    reinviteAdminUser(id: $id)
  }
`

export const GET_ADMIN_USER_STATS = gql`
  query adminUserStats_UI($adminUserId: String!) {
    adminUserStats(adminUserId: $adminUserId) {
      stats
    }
  }
`

export const SA_GET_ADMIN_USER = gql`
  query saAdminUser_UI($input: SaAdminUserInput!) {
    saAdminUser(input: $input) {
      builder {
        company {
          name
        }
      }
      user {
        firstName
        lastName
      }
      ...adminUserAttributes
    }
  }
  ${ADMIN_USER_ATTRIBUTES}
`

export const GET_ADMIN_USER_INFO = gql`
  query adminUserInfo_UI($id: String!) {
    adminUser(id: $id) {
      id
      mobile
      user {
        id
        firstName
        lastName
        email
      }

      projects {
        id
        name
        status
      }
    }
  }
`

export const SWITCH_BUILDER = gql`
  mutation switchBuilder_UI($orgId: String!) {
    switchBuilder(orgId: $orgId) {
      id
    }
  }
`
